type IdWithSegmentIndex = string;

/**
 * @description utility functions for working with ids
 */
export class IdUtils {
  /**
   * @description Generates a stable, deterministic string key from two IDs by sorting them
   * @example
   * toSortedIdKey('idA', 'idB') => 'idA_idB'
   * toSortedIdKey('idB', 'idA') => 'idA_idB'
   */
  static toSortedIdKey = (idA: string, idB: string): string =>
    idB < idA ? `${idB}_${idA}` : `${idA}_${idB}`;

  /**
   * @description Generates a deterministic ID with the segment index encoded in the ID itself
   * @example
   * buildIdWithSegmentIndex('id1', 3) => 'id1.3'
   * buildIdWithSegmentIndex('id34', '7') => 'id34.7'
   */
  static buildIdWithSegmentIndex = (areaId: string, segmentIndex: number): IdWithSegmentIndex => {
    const id: IdWithSegmentIndex = `${areaId}.${segmentIndex}`;

    return id;
  };

  /**
   * @description Destructures a deterministic IdWithSegmentIndex into its areaId and segmentIndex
   * @example
   * destructureIdWithSegmentIndex('id1.0') => '{areaId: 'id1', segmentIndex: 0}'
   * destructureIdWithSegmentIndex('id34.7') => '{areaId: 'id34', segmentIndex: 7}'
   */
  static destructureIdWithSegmentIndex = (
    idWithSegmentIndex: string,
  ): {
    areaId: string;
    segmentIndex: number | undefined;
  } => {
    const [areaId, segmentIndex] = idWithSegmentIndex.split('.');

    return {
      areaId,
      segmentIndex: segmentIndex ? Number(segmentIndex) : undefined,
    };
  };
}
